import { render, staticRenderFns } from "./query-form.vue?vue&type=template&id=b44d70c2&scoped=true&"
import script from "./query-form.vue?vue&type=script&lang=js&"
export * from "./query-form.vue?vue&type=script&lang=js&"
import style0 from "./query-form.vue?vue&type=style&index=0&id=b44d70c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44d70c2",
  null
  
)

export default component.exports